import { render, staticRenderFns } from "./FilterAgendamentos.vue?vue&type=template&id=2f00c5a5"
import script from "./FilterAgendamentos.vue?vue&type=script&lang=js"
export * from "./FilterAgendamentos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports